import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../authConfig";
import {
  InteractionRequiredAuthError,
  InteractionStatus
} from "@azure/msal-browser";

export default function useFetchToken() {
  const { instance, inProgress } = useMsal();

  const account = instance.getActiveAccount();

  const tokenRequest = { ...loginRequest, account };

  const fetchToken = async () => {
    if (!account || inProgress !== InteractionStatus.None) return null;

    try {
      // first we try silently acquiring token without interaction
      const response = await instance.acquireTokenSilent(tokenRequest);
      return response.accessToken;
    } catch (e) {
      // user interaction is required
      if (e instanceof InteractionRequiredAuthError) {
        try {
          // Attempt using popup to acquire token to avoid data loss
          const response = await instance.acquireTokenPopup(tokenRequest);
          return response.accessToken;
        } catch (e) {
          if (inProgress !== InteractionStatus.None) {
            console.error(e);
            return null;
          } else {
            try {
              // fallback to redirect attempt just in case.
              instance.acquireTokenRedirect(tokenRequest);
            } catch (e) {
              console.error(e);
              return null;
            }
          }
        }
      } else {
        console.error(e);
        return null;
      }
    }
  };

  return {
    fetchToken
  };
}
